module.exports = {
  AED: 'AED',
  ALL: 'ALL',
  ARS: 'ARS',
  AUD: 'AUD',
  BAM: 'BAM',
  BGN: 'BGN',
  BRL: 'BRL',
  CAD: 'CAD',
  CHF: 'CHF',
  CNY: 'CNY',
  COP: 'COP',
  CZK: 'CZK',
  DKK: 'DKK',
  DZD: 'DZD',
  EUR: 'EUR',
  GBP: 'GBP',
  HKD: 'HKD',
  HRK: 'HRK',
  HUF: 'HUF',
  ISK: 'ISK',
  JPY: 'JPY',
  KRW: 'KRW',
  MAD: 'MAD',
  MKD: 'MKD',
  MUR: 'MUR',
  MXN: 'MXN',
  MYR: 'MYR',
  NOK: 'NOK',
  NZD: 'NZD',
  OMR: 'OMR',
  PEN: 'PEN',
  PLN: 'PLN',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  SEK: 'SEK',
  THB: 'THB',
  TRY: 'TRY',
  TWD: 'TWD',
  UAH: 'UAH',
  USD: 'USD',
  VND: 'VND',
  ZAR: 'ZAR'
};
